import { useHistory, useLocation } from "react-router-dom";

import { TabButtons, TabHealthera } from '../../healtheraComponents';

const routesMapper = {
  '/ecommerce/banners': 0,
  '/ecommerce/categories': 1,
}

const getActiveTab = (url) => {
  const currentRoute = Object.keys(routesMapper).find(route => url.includes(route));
  return routesMapper[currentRoute] || 0;
};

function ECommenrceTabs() {
  const location = useLocation();
  const history = useHistory();

  function handleTabChange(_, tabIndex) {
    if (routesMapper[location.pathname] === tabIndex) return;
    if (tabIndex === 0) return history.push('/ecommerce/banners');
    if (tabIndex === 1) return history.push('/ecommerce/categories');
    history.push('/');
  }

  return (
    <TabButtons
      height={`64px`}
      value={getActiveTab(location.pathname)}
      onChange={handleTabChange}>
      <TabHealthera label="Banners"/>
      <TabHealthera label="Categories" />
    </TabButtons>
  );
}

export default ECommenrceTabs;
